import type { IFilterOption } from "Common/Interfaces";

export const isFilterValueChecked = (valueId: number | string, queryParam?: string) => {
  if (!queryParam) return false;

  // Encode the valueId to match the encoded format in the query param
  const encodedValueId = typeof valueId === "number" ? valueId.toString() : encodeURIComponent(valueId.toString());
  return queryParam.split(",").includes(encodedValueId);
};

export const isFilterValueCheckedForFilterState = (
  filterState: IFilterOption[] | undefined,
  filterId: number,
  valueId: number | string,
) => {
  if (!filterState) return false;

  const filter = filterState.find((f) => f.id === filterId);
  if (!filter) return false;

  return filter.checkboxValues?.some((v) => v.value === valueId && v.isChecked) ?? false;
};
